import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import usePriorityModal from "./usePriorityModal";

const PriorityModal = ({
  closeModal,
  branch_currency_id,
  refetch,
  display_order,
}) => {
  const { formik, getFieldError } = usePriorityModal({
    closeModal,
    branch_currency_id,
    refetch,
    display_order,
  });
  return (
    <>
      <div className="pro-m-3">
        <Input
          label={"Priority order*"}
          type="text"
          id="display_order"
          name="display_order"
          className={`pro-input lg ${
            formik?.errors?.display_order &&
            formik?.touched?.display_order &&
            "error"
          }`}
          {...formik.getFieldProps("display_order")}
          // onChange={(event) => capitalizeOnSpace(event, formik.setFieldValue)}
          error={getFieldError("display_order")}
          errorMessage={getFieldError("display_order")}
        />
      </div>
      <div className={`col-12 pro-d-flex pro-justify-end `}>
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={() => closeModal()}
        >
          Cancel
        </Button>

        <Button
          className={`pro-btn-primary lg pro-ms-3 ${
            formik?.isSubmitting ? "loading" : ""
          }`}
          type="submit"
          // disabled={hasUpdatePermission === true ? false : true}
          onClick={formik.handleSubmit}
        >
          {"Submit"}
        </Button>
      </div>
    </>
  );
};

export default PriorityModal;
